/**
 * Created by Andrew on 6/10/2016.
 */

import React, { Component } from 'react';
import CustomerDetails from '../presentation/customer-details';

export default class CustomerInformationWidget extends Component {
    constructor(props) {
        super(props);

        this.state = {
            accountState : this.props.account.state || null
        }
    }

    toggleAccountActive = () => {
        if( this.state.accountState === "ACTIVE" ) {
            if(confirm("Are you sure you want to proceed with the deactivation of this account?")) {
                fetch("/service/deactivateCustomer", {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('idToken')}`
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify({accountId: this.props.account._id})
                }).then(response => {
                    if (response.status != 200) {
                        alert("Error: Account could not be deactivated");
                    } else {
                        alert("Account has been deactivated successfully");
                        this.setState({ accountState: "DELETED" });
                    }
                });
            }
        } else {
            if(confirm("Are you sure you want to proceed with the activation of this account?")) {
                fetch("/service/activateCustomer", {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('idToken')}`
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify({accountId: this.props.account._id})
                }).then(response => {
                    if (response.status != 200) {
                        alert("Error: Account could not be activated");
                    } else {
                        alert("Account has been activated successfully");
                        this.setState({accountState: "ACTIVE"});
                    }
                });
            }
        }
    };

    updateAccountName = (name) => {
        return fetch("/service/updateAccountName", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('idToken')}`
            },
            credentials: 'same-origin',
            body: JSON.stringify({ accountId: this.props.account._id, name })
        }).then(response => {
            if (response.status != 204) {
                alert("Error: Account name could not be updated");
            }
        });
    }

    updateAccountType = (type) => {
        return fetch("/service/updateAccountType", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('idToken')}`
            },
            credentials: 'same-origin',
            body: JSON.stringify({ accountId: this.props.account._id, type })
        }).then(response => {
            if (response.status != 204) {
                alert("Error: Account type could not be updated");
            }
        });
    }

    render() {
        return (
            <CustomerDetails 
                account={this.props.account} 
                toggleAccountActive={this.toggleAccountActive} 
                accountState={this.state.accountState}
                updateAccountName={this.updateAccountName}
                updateAccountType={this.updateAccountType}
            />
        )
    }
}
